import React from 'react'

import GridDefault from './gridDefault'
import ListDefault from './listDefault'
import GridVideo from './gridVideo'
import siteConfig from '../../../common/utils/siteConfig'

/**
 * if a site only has one view type, we force to use it
 * other wise we use the user preference
 * @param  {String} expectedViewType
 * @param  {String} currentSite
 * @return {String} the final view type we use
 */
export const getFinalViewType = (expectedViewType, currentSite) => {
  const siteDefaultViewType = siteConfig(currentSite, 'default_category_view')
  if (!expectedViewType) return siteDefaultViewType

  const itemViewsConfig = siteConfig(currentSite, 'ui.item_list_views') || []
  // a few sites only have one view type, we force to use it
  if (itemViewsConfig.length === 1) {
    return itemViewsConfig[0].value
  } else {
    return expectedViewType
  }
}

const ProductList = ({items, currentSite, preferences, itemDecorator}) => {
  const viewType = getFinalViewType(preferences.searchResultsViewType, currentSite)
  const videoMuted = preferences.searchVideoMuted

  if (viewType === 'grid') {
    if (currentSite === 'videohive') {
      return <GridVideo
        items={items}
        viewType={viewType}
        videoMuted={videoMuted}
        currentSite={currentSite}
        itemDecorator={itemDecorator}
      />
    } else {
      return <GridDefault
        items={items}
        viewType={viewType}
        currentSite={currentSite}
        itemDecorator={itemDecorator}
      />
    }
  } else {
    return <ListDefault
      items={items}
      viewType={viewType}
      currentSite={currentSite}
      itemDecorator={itemDecorator}
    />
  }
}

export default ProductList



// WEBPACK FOOTER //
// ./client/components/productList/index.js